/*!
  Atom, by Koding Themes
  accessibility.js
  https://kodingthemes.com
*/

function getFocusableElements(container) {
   return Array.from(container.querySelectorAll("summary, a[href], button:enabled, fieldset, [tabindex]:not([tabindex^='-']), [draggable], area, select, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"));
}
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
   var elements = getFocusableElements(container);
   var first = elements[0];
   var last = elements[elements.length - 1];
   removeTrapFocus();
   trapFocusHandlers.focusin = (event) => {
      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', trapFocusHandlers.keydown);
   };
   trapFocusHandlers.focusout = function() {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
   };
   trapFocusHandlers.keydown = function(event) {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
         event.preventDefault();
         first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
         event.preventDefault();
         last.focus();
      }
   };
   document.addEventListener('focusout', trapFocusHandlers.focusout);
   document.addEventListener('focusin', trapFocusHandlers.focusin);
   elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
   document.removeEventListener('focusin', trapFocusHandlers.focusin);
   document.removeEventListener('focusout', trapFocusHandlers.focusout);
   document.removeEventListener('keydown', trapFocusHandlers.keydown);
   if (elementToFocus) elementToFocus.focus();
}

// Accessibility helpers
document.addEventListener("DOMContentLoaded", function() {
   // Secure target href links
   document.querySelectorAll("a[target=_blank]").forEach(function(item) {
      item.setAttribute("rel", "noopener noreferrer");
   });
   document.querySelectorAll('.ss-list').forEach(function(select) {
      select.setAttribute('aria-label', select.closest('.product-option-row')?.querySelector('.option-name')?.textContent?.trim() || 'Options');
   });

   // Selectors
   var sidebar = document.querySelectorAll(".js-menu-toggle");
   var addToCartBtn = document.querySelector('.add-to-cart-button');
   var mainMenu = document.querySelector('.js-menu-toggle-home');

   var cartSummary = document.querySelector(".mini-cart-recommendations");
   if (cartSummary != null) {
      var cartBtn = cartSummary.querySelector(".mini-container");
      var span = cartSummary.querySelector(".tax-note");
      if (span != null) {
         span.addEventListener("focusout", function(e) {
            document.querySelector('body').classList.remove('show-sidebar');
            if (mainMenu != null) mainMenu.focus();
         });
      }
   }

   // If cart icon is focused
   if (sidebar != null) {
      sidebar.forEach(function(item) {
         item.addEventListener('click', function() {
            var sidebarEl = document.querySelector('aside.sidebar');
            if (sidebarEl != null) {
               sidebarEl.setAttribute('tabindex', 0);
               sidebarEl.focus();
            }
         });
      });
   }

   // Move focus to cart drawer
   if (addToCartBtn != null) {
      addToCartBtn.addEventListener('click', function() {
         var sidebarEl = document.querySelector("aside.sidebar");
         if (sidebarEl != null) sidebarEl.focus();
      });
   }
});

document.addEventListener("keydown", function(event) {
   var activeElement = document.activeElement;

   // Click on the warranty product
   if (event.key === "Enter") {
      if (document.querySelector('#warrantyProduct') != null) {
         var warrantyProduct = document.querySelector('#warrantyProduct');
         var productWarrantyBtn = document.querySelector('.product-warranty-btn');
         if (document.activeElement === productWarrantyBtn) {
            warrantyProduct.click();
         }
      }
   }

   // Click on the upsell product
   if (event.key === "Enter") {
      document.querySelectorAll('input[name="upsellProduct[]"]').forEach(function(item) {
         var productUpsellBtn = item.closest('.product-upsell-btn-wrp')?.querySelector('.product-upsell-btn');
         if (productUpsellBtn != null && document.activeElement === productUpsellBtn) {
            item.click();
         }
      });
   }

   // Show product details on button enter
   if (event.key === "Enter") {
      document.querySelectorAll('.product-overview__feature-btn').forEach(function(self) {
         if (document.activeElement === self) {
            document.querySelector('.product-features')?.classList.toggle("product-features--show");
            document.querySelector('.product-features')?.classList.toggle('active');
         }
      });
   }

   // Shift+Tab cart line item navigation
   if (event.shiftKey && event.key === "Tab") {
      var cartSelector = document.querySelectorAll('#cart').length > 0
         ? '#page-cart-inner #cart-fieldset'
         : '#cart-fieldset';
      document.querySelectorAll(cartSelector + ' .cart-items>.line-item').forEach(function(selfClass) {
         var removeBtn = selfClass.querySelector('.remove-lines');
         if (removeBtn == document.activeElement) {
            event.preventDefault();
            selfClass.querySelector('.line-image a')?.focus();
         }
      });
   }

   // Tab forward navigation
   if (event.key === "Tab" && !(event.shiftKey)) {
      if (document.querySelectorAll('#product').length > 0) {
         var doc1 = document.activeElement;

         var doc2 = document.querySelector('.featured-products>.collection-toggle:last-child .add-to-cart-button');
         if (doc1 == doc2) {
            event.preventDefault();
            document.querySelector('.main-featured-products .glider-prev')?.focus();
         }

         var doc3 = document.querySelector('.main-featured-products .glider-prev');
         if (doc1 == doc3) {
            event.preventDefault();
            document.querySelector('.main-featured-products .glider-next')?.focus();
         }

         var doc4 = document.querySelector('.section-product-tabs .nav-tabs .nav-item:last-child .nav-link');
         if (doc1 == doc4) {
            var recPrev = document.querySelector('.product-recomendations-section .controls-rec .glider-prev');
            if (recPrev) {
               event.preventDefault();
               recPrev.focus();
            }
         }

         var doc5 = document.querySelector('.product-recomendations-section .controls-rec .glider-prev');
         if (doc1 == doc5) {
            var recNext = document.querySelector('.product-recomendations-section .controls-rec .glider-next');
            if (recNext) {
               event.preventDefault();
               recNext.focus();
            }
         }

         var doc6 = document.querySelector('.product-recomendations-section .controls-rec .glider-next');
         if (doc1 == doc6) {
            var recFirst = document.querySelector('#product_recomendation_body .rec-products:first-child .product-details-card a');
            if (recFirst) {
               event.preventDefault();
               recFirst.focus();
            }
         }

         var doc7 = document.querySelector('#product_recomendation_body .rec-products:last-child .product-thumb');
         if (doc1 == doc7) {
            var rvPrev = document.querySelector('.recently-viewed-section .controls .glider-prev');
            if (rvPrev) {
               event.preventDefault();
               rvPrev.focus();
            }
         }

         var doc8 = document.querySelector('.recently-viewed-section .controls .glider-prev');
         if (doc1 == doc8) {
            var rvNext = document.querySelector('.recently-viewed-section .controls .glider-next');
            if (rvNext) {
               event.preventDefault();
               rvNext.focus();
            }
         }

         var doc9 = document.querySelector('.recently-viewed-section .controls .glider-next');
         if (doc1 == doc9) {
            var rvFirst = document.querySelector('.recently_viewed_products2>div:first-child .product-details-card a');
            if (rvFirst) {
               event.preventDefault();
               rvFirst.focus();
            }
         }

         var doc10 = document.querySelector('.recently_viewed_products2>div:last-child .product-thumb');
         if (doc1 == doc10) {
            var footerFirst = document.querySelector('.footer-top #accordion .links-list .footer-menu:first-child a');
            if (footerFirst) {
               event.preventDefault();
               footerFirst.focus();
            }
         }

         var doc11 = document.querySelector('#MainContent');
         if (doc1 == doc11) {
            if (document.querySelector('.product-medaia-slider-controls .glider-prev')) {
               event.preventDefault();
               document.querySelector('.product-medaia-slider-controls .glider-prev').focus();
            } else if (document.querySelector('.product-images .slides div a')) {
               event.preventDefault();
               document.querySelector('.product-images .slides div a').focus();
            }
         }

         var doc12 = document.querySelector('.product-medaia-slider-controls .glider-prev');
         if (doc1 == doc12) {
            var activeSlide = document.querySelector('.js-slides .tns-slide-active a');
            if (activeSlide) {
               event.preventDefault();
               activeSlide.focus();
            }
         }

         var doc13 = document.querySelector('.js-slides .tns-slide-active a');
         if (doc1 == doc13) {
            var sliderNext = document.querySelector('.product-medaia-slider-controls .glider-next');
            if (sliderNext) {
               event.preventDefault();
               sliderNext.focus();
            }
         }

         var doc14 = document.querySelector('.product-medaia-slider-controls .glider-next');
         if (doc1 == doc14) {
            if (document.querySelector('#controls-thumbnails .glider-prev') && document.querySelector('#controls-thumbnails').style.display != 'none') {
               event.preventDefault();
               document.querySelector('#controls-thumbnails .glider-prev').focus();
            } else if (document.querySelector('.product-thumbnails > a.tns-slide-active')) {
               event.preventDefault();
               document.querySelectorAll('.product-thumbnails > a.tns-slide-active')[0].focus();
            } else if (document.querySelector('.single-product-details > a')) {
               event.preventDefault();
               document.querySelector('.single-product-details > a').focus();
            } else if (document.querySelector('.product-vendor a')) {
               event.preventDefault();
               document.querySelector('.product-vendor a').focus();
            }
         }

         var doc15 = document.querySelector('#controls-thumbnails .glider-prev');
         if (doc1 == doc15) {
            var activeThumb = document.querySelector('.product-thumbnails > a.tns-slide-active');
            if (activeThumb) {
               event.preventDefault();
               activeThumb.focus();
            }
         }

         var docAll = document.querySelectorAll('.product-thumbnails > a.tns-slide-active');
         var doc16 = docAll[docAll.length - 1];
         if (doc1 == doc16) {
            if (document.querySelector('#controls-thumbnails .glider-next') && document.querySelector('#controls-thumbnails').style.display != 'none') {
               event.preventDefault();
               document.querySelector('#controls-thumbnails .glider-next').focus();
            } else if (document.querySelector('.single-product-details a')) {
               event.preventDefault();
               document.querySelector('.single-product-details a').focus();
            }
         }

         var doc17 = document.querySelector('#controls-thumbnails .glider-next');
         if (doc1 == doc17) {
            var detailsLink = document.querySelector('.single-product-details > a');
            if (detailsLink) {
               event.preventDefault();
               detailsLink.focus();
            }
         }
      }

      // Cart page tab navigation
      if (document.querySelectorAll('#cart').length > 0) {
         var lastNavLink = document.querySelector('.navbar-nav.main-menu>.menu-item:last-child>.nav-link');
         var currentActive = document.activeElement;
         if (lastNavLink == currentActive) {
            var firstLineImage = document.querySelector('#page-cart-inner #cart-fieldset .cart-items>.line-item:first-child .line-image a');
            if (firstLineImage) {
               event.preventDefault();
               firstLineImage.focus();
            }
         }
         document.querySelectorAll('#page-cart-inner #cart-fieldset .cart-items>.line-item').forEach(function(selfClass, index) {
            var plusBtn = selfClass.querySelector('.js-quantity-button.plus');
            if (plusBtn == currentActive) {
               var nextLineImage = document.querySelector('#page-cart-inner #cart-fieldset .cart-items>.line-item:nth-child(' + (index + 2) + ') .line-image a');
               if (nextLineImage) {
                  event.preventDefault();
                  nextLineImage.focus();
               }
            }
         });
      }
   }
});

// Accordion functionality
if (document.querySelectorAll('.faq-item-wrapper .faq-item').length > 0) {
   document.querySelectorAll('.faq-item-wrapper .faq-item').forEach(function(item) {
      item.onclick = function() {
         var content = item.closest('.faq-item-wrapper').querySelector('.faq-item-content');
         if (content != null) {
            content.classList.toggle('hidden');
         }
      };
   });
}

// Accordion keyboard accessibility
if (document.querySelectorAll('.faq-item-wrapper').length > 0) {
   document.addEventListener("keydown", function(event) {
      if (event.key === "Enter") {
         document.querySelectorAll('.faq-item-wrapper').forEach(function(self) {
            var itemContent = self.querySelector('.faq-item-content');
            if (document.activeElement === self && itemContent != null) {
               itemContent.classList.toggle('hidden');
            }
         });
      }
   });
}

// Skip to content focus
window.addEventListener("load", function() {
   var skipContent = document.querySelector(".skip-to-content-link");
   if (skipContent != null) {
      document.body.setAttribute('tabindex', -1);
      skipContent.focus();
      skipContent.style.opacity = 0;
      skipContent.style.visibility = 'hidden';
   }
});

// Main keyboard navigation handler
document.addEventListener("keydown", function(event) {
   var activeElement = document.activeElement;
   setTimeout(function() {
      var skipContent = document.querySelector(".skip-to-content-link");
      var logo = document.querySelector('.shop-link');
      var searchBox = document.querySelector('.top-header .input-group');
      var sidebarCartIcon = document.querySelector(".js-menu-toggle");
      var searchLinkIcon = document.querySelector(".js-search-modal-link");
      var searchModalClose = document.querySelector(".search-modal-close");
      var cartClose = document.querySelector(".js-close-cart");
      var mainMenu = document.querySelector('.js-menu-toggle-home');
      if (mainMenu == null) return;
      var openMenu = mainMenu.querySelector('.open-menu-hamburger');
      var closeMenu = mainMenu.querySelector('.close-menu-hamburger');
      var prentItemList = document.querySelectorAll('.sidebar-menu-list-parent li a');
      var menuParentFirstItem = document.querySelector('.sidebar-menu-list-parent li:first-child a');
      var accountMenu = document.querySelector('.main-sidebar .js-account a');
      var socailMediaTop = document.querySelector('.top-header .social-media-grid a');
      var slideShow = document.querySelector('.new-animation-slider');
      var slideShowPrev = document.querySelector('.slide-navigation-item-prev');
      var breadcrumb = document.querySelector('.breadcrumb-item:first-child a');
      var labelsFilter = document.querySelectorAll('.collection-filter-sidebar .form-check-label');

      if (event.key === "Tab" && !(event.shiftKey)) {
         // Next after skip content
         if (activeElement == skipContent && logo != null) {
            logo.focus({ focusVisible: true });
         }
         // Next after logo
         if (activeElement == logo && searchBox != null) {
            searchBox.focus();
         }
         if (activeElement == logo && socailMediaTop != null) {
            socailMediaTop.focus();
         }
         // Next after search icon
         if (activeElement == searchLinkIcon) {
            mainMenu.focus({ focusVisible: true });
         }
         // Next after search modal
         if (activeElement == searchModalClose) {
            document.body.classList.remove('show-search-modal');
            mainMenu.focus({ focusVisible: true });
         }
         // Close search modal
         document.querySelectorAll(".search-results li:last-child a.js-search-result-page-link").forEach(function(searchPageLink) {
            if (activeElement == searchPageLink) {
               var searchResult = activeElement.closest('.search-results');
               searchResult.innerHTML = '';
               searchResult.style.display = 'none';
               if (document.body.classList.contains('show-search-modal')) {
                  document.body.classList.remove('show-search-modal');
                  mainMenu.focus({ focusVisible: true });
               }
            }
         });
         // Next after open menu — close when tabbing past last item
         var tabindexedItems = document.querySelectorAll('.sidebar-mega-menu-list li a[tabindex="0"]');
         if (tabindexedItems.length > 0) {
            var tabindexedLastItem = tabindexedItems[tabindexedItems.length - 1];
            if (activeElement == tabindexedLastItem) {
               document.body.classList.remove('show-sidebar-main');
               document.body.classList.remove('active');
               document.querySelectorAll('.sidebar-mega-menu-list li a').forEach(function(item) {
                  item.setAttribute('tabindex', -1);
                  var isNextCol = item.dataset.nextcolumn;
                  if (isNextCol != undefined) {
                     var goNextCol = item.closest('li').querySelector('.dropdown-toggle');
                     if (goNextCol) goNextCol.setAttribute('tabindex', -1);
                  }
               });
            }
         }
         // Next after account menu
         if (slideShow != null && accountMenu != null && activeElement == accountMenu) {
            slideShow.focus();
         }
         if (breadcrumb != null && accountMenu != null && activeElement == accountMenu) {
            breadcrumb.focus();
         }
         // Next after slide section
         if (slideShow != null && slideShowPrev != null && activeElement == slideShow) {
            slideShowPrev.focus();
         }
         // Scroll filter labels into view
         if (labelsFilter.length > 0) {
            labelsFilter.forEach(function(label) {
               if (activeElement == label && typeof gsap !== 'undefined') {
                  gsap.to(window, { duration: 1, scrollTo: label });
               }
            });
         }
         // For product page
         var breadcrumbLast = document.querySelector('.breadcrumb-item:last-child a');
         var productDetails = document.querySelector('.single-product-details form a.focus-inset');
         if (breadcrumbLast != null && productDetails != null && activeElement == breadcrumbLast) {
            productDetails.focus();
         }
      }

      if (event.key === "Enter") {
         // Search modal
         if (activeElement == searchLinkIcon) {
            var modal = searchLinkIcon.closest('.header-search-nav');
            var modalSearch = modal?.querySelector('.js-search-input');
            if (modalSearch != null) {
               modalSearch.focus();
            }
         }
         if (activeElement == searchModalClose) {
            document.body.classList.remove('show-search-modal');
            mainMenu.focus({ focusVisible: true });
         }

         if (activeElement == cartClose) {
            cartClose.click();
            setTimeout(function() {
               if (searchLinkIcon) {
                  searchLinkIcon.focus({ focusVisible: true });
               }
            }, 100);
         }

         // Collection filter
         if (labelsFilter.length > 0) {
            labelsFilter.forEach(function(label) {
               if (activeElement == label) {
                  label.click();
               }
            });
         }

         // Sidebar menu toggle
         if (activeElement == mainMenu) {
            setTimeout(function() {
               if (openMenu != null && !document.body.classList.contains('show-sidebar-main')) {
                  document.body.classList.add('show-sidebar-main');
                  document.body.classList.add('active');
                  prentItemList.forEach(function(item) {
                     item.setAttribute('tabindex', 0);
                     var isNextCol = item.dataset.nextcolumn;
                     if (isNextCol != undefined) {
                        var goNextCol = item.closest('li').querySelector('.dropdown-toggle');
                        if (goNextCol) goNextCol.setAttribute('tabindex', 0);
                     }
                  });
                  if (menuParentFirstItem) {
                     menuParentFirstItem.focus({ focusVisible: true });
                  }
               } else if (closeMenu != null && document.body.classList.contains('show-sidebar-main')) {
                  document.body.classList.remove('show-sidebar-main');
                  document.body.classList.remove('active');
                  prentItemList.forEach(function(item) {
                     item.setAttribute('tabindex', -1);
                     var isNextCol = item.dataset.nextcolumn;
                     if (isNextCol != undefined) {
                        var goNextCol = item.closest('li').querySelector('.dropdown-toggle');
                        if (goNextCol) goNextCol.setAttribute('tabindex', -1);
                     }
                  });
               }
            }, 100);
         }

         // Sidebar menu column navigation
         setTimeout(function() {
            var toggleMenuItems = document.querySelectorAll('.sidebar-mega-menu-list li .dropdown-toggle');

            // Reset all columns first
            toggleMenuItems.forEach(function(item) {
               var nextCol = item.closest('li').querySelector('a')?.dataset.nextcolumn;
               if (nextCol != null) {
                  var enableCol = document.querySelector('.' + nextCol);
                  if (enableCol) {
                     enableCol.closest('.sidebar-menu-columns').classList.remove('active-sidebar-nav-column');
                     enableCol.closest('.sidebar-menu-columns').style.width = '0';
                     enableCol.style.display = 'none';
                     enableCol.querySelectorAll('li').forEach(function(listItem) {
                        var link = listItem.querySelector('a');
                        if (link) link.setAttribute('tabindex', -1);
                        var toggle = listItem.querySelector('.dropdown-toggle');
                        if (toggle) toggle.setAttribute('tabindex', -1);
                     });
                  }
               }
            });

            // Activate the column for the focused toggle
            toggleMenuItems.forEach(function(item) {
               var nextCol = item.closest('li').querySelector('a')?.dataset.nextcolumn;
               if (nextCol != null && activeElement == item) {
                  // Hide items after this toggle in current list
                  setTimeout(function() {
                     var currentTabindexList = item.closest('.sidebar-mega-menu-list').querySelectorAll('[tabindex="0"]');
                     var tabindexStatus = 0;
                     currentTabindexList.forEach(function(tabindexItem) {
                        if (tabindexStatus == 0) {
                           if (tabindexItem == item) {
                              tabindexStatus = -1;
                           }
                        } else {
                           tabindexItem.setAttribute('tabindex', -1);
                        }
                     });
                  }, 100);

                  // Enable current col when this is a child col
                  var currentStep = item.closest('.sidebar-menu-columns').dataset.currentstep;
                  if (currentStep == 'child') {
                     var currentCol = item.closest('ul');
                     currentCol.closest('.sidebar-menu-columns').classList.add('active-sidebar-nav-column');
                     currentCol.closest('.sidebar-menu-columns').style.width = '100%';
                     currentCol.style.display = 'block';
                     currentCol.querySelectorAll('li').forEach(function(listItem, index) {
                        var link = listItem.querySelector('a');
                        if (link) link.setAttribute('tabindex', 0);
                        var toggle = listItem.querySelector('.dropdown-toggle');
                        if (toggle) toggle.setAttribute('tabindex', 0);
                        if (index == 0 && link) link.focus();
                     });
                  }

                  // Enable next col
                  var enableCol = document.querySelector('.' + nextCol);
                  if (enableCol) {
                     enableCol.closest('.sidebar-menu-columns').classList.add('active-sidebar-nav-column');
                     enableCol.closest('.sidebar-menu-columns').style.width = '100%';
                     enableCol.style.display = 'block';
                     enableCol.querySelectorAll('li').forEach(function(listItem, index) {
                        var link = listItem.querySelector('a');
                        if (link) link.setAttribute('tabindex', 0);
                        var toggle = listItem.querySelector('.dropdown-toggle');
                        if (toggle) toggle.setAttribute('tabindex', 0);
                        if (index == 0 && link) link.focus();
                     });
                  }
               }
            });
         }, 100);

         // Cart drawer focus
         var addToCartBtn = document.querySelector('.add-to-cart-button');
         if (addToCartBtn != null) {
            var sidebarEl = document.querySelector('aside.sidebar');
            if (sidebarEl) {
               sidebarEl.setAttribute('tabindex', 0);
               sidebarEl.focus({ focusVisible: true });
            }
         }

         // Product input pills
         var radioWraps = document.querySelectorAll('.styled-pills-radio');
         radioWraps.forEach(function(radioWrap) {
            radioWrap.querySelectorAll('input[type="radio"]').forEach(function(radio) {
               var inputSelector = activeElement.getAttribute('for');
               if (activeElement.closest('.styled-pills-radio') != null && inputSelector) {
                  var radioTofocus = activeElement.closest('.styled-pills-radio').querySelector('#' + inputSelector);
                  if (radioTofocus == radio) {
                     radioTofocus.checked = true;
                     radioTofocus.onchange();
                     activeElement.focus();
                  }
               }
            });
         });
      }

      if (event.key === "Escape") {
         if (document.body.classList.contains('show-sidebar-main')) {
            if (closeMenu) closeMenu.click();
            document.querySelectorAll('.sidebar-menu [tabindex="0"]').forEach(function(item) {
               item.setAttribute('tabindex', -1);
            });
            mainMenu.focus();
         }
      }

      if (event.shiftKey && event.key === "Tab") {
         // Shift+Tab after header
         if (activeElement == searchBox && logo != null) {
            logo.focus();
         }
         if (activeElement == socailMediaTop && logo != null) {
            logo.focus();
         }
         // Shift+Tab after slideshow
         if (slideShow != null && accountMenu != null && activeElement == slideShow) {
            accountMenu.focus();
         }
         // Breadcrumb to account menu
         if (breadcrumb != null && accountMenu != null && activeElement == breadcrumb) {
            accountMenu.focus();
         }
         // Filter item access
         var inputSortBy = document.querySelector('.ss-search input[type="search"]');
         var clearFilter = document.querySelector('.filter-form .clear-button');
         if (inputSortBy != null && clearFilter != null && activeElement == inputSortBy && typeof gsap !== 'undefined') {
            gsap.to(window, { duration: 1, scrollTo: clearFilter });
         }
         if (labelsFilter.length > 0) {
            labelsFilter.forEach(function(label) {
               if (activeElement == label && typeof gsap !== 'undefined') {
                  gsap.to(window, {
                     duration: 1,
                     scrollTo: { y: label, offsetY: 200 }
                  });
               }
            });
         }
         // Close search modal on shift+tab
         if (searchLinkIcon != null) {
            var modal = searchLinkIcon.closest('.header-search-nav');
            var modalSearchInput = modal?.querySelector('.js-search-input');
            if (modalSearchInput != null && activeElement == modalSearchInput) {
               document.body.classList.remove('show-search-modal');
               searchLinkIcon.focus();
            }
         }
         // Close sidebar menu on shift+tab
         if (mainMenu == activeElement) {
            if (searchLinkIcon) searchLinkIcon.focus();
            document.body.classList.remove('show-sidebar-main');
            document.body.classList.remove('active');
            prentItemList.forEach(function(item) {
               item.setAttribute('tabindex', -1);
               var isNextCol = item.dataset.nextcolumn;
               if (isNextCol != undefined) {
                  var goNextCol = item.closest('li').querySelector('.dropdown-toggle');
                  if (goNextCol) goNextCol.setAttribute('tabindex', -1);
               }
            });
         }
         // Menu column to close icon
         var parentListFirstItem = document.querySelector('.sidebar-mega-menu-list li:first-child a[tabindex="0"]');
         if (parentListFirstItem != null && activeElement == parentListFirstItem) {
            document.body.classList.remove('show-sidebar-main');
            document.body.classList.remove('active');
            prentItemList.forEach(function(item) {
               item.setAttribute('tabindex', -1);
               var isNextCol = item.dataset.nextcolumn;
               if (isNextCol != undefined) {
                  var goNextCol = item.closest('li').querySelector('.dropdown-toggle');
                  if (goNextCol) goNextCol.setAttribute('tabindex', -1);
               }
            });
            setTimeout(function() {
               mainMenu.focus();
            }, 100);
         }
         // Sidebar menu col close — navigate back through columns
         document.querySelectorAll('.sidebar-mega-menu-list li:first-child a[tabindex="0"]').forEach(function(item) {
            if (activeElement == item && item.closest('.sidebar-menu-list-parent') == null) {
               var disableCol = item.closest('ul');
               if (disableCol) {
                  disableCol.closest('.sidebar-menu-columns').classList.remove('active-sidebar-nav-column');
                  disableCol.closest('.sidebar-menu-columns').style.width = '0';
                  disableCol.style.display = 'none';
                  disableCol.querySelectorAll('li').forEach(function(listItem) {
                     var link = listItem.querySelector('a');
                     if (link) link.setAttribute('tabindex', -1);
                     var toggle = listItem.querySelector('.dropdown-toggle');
                     if (toggle) toggle.setAttribute('tabindex', -1);
                  });

                  // Re-enable parent column items
                  var currentColstep = item.closest('.sidebar-menu-columns').dataset.currentstep;
                  if (currentColstep == 'grandchild') {
                     document.querySelectorAll('.sidebar-menu-columns-child .sidebar-menu-list-child').forEach(function(list) {
                        if (list.style.display == 'block') {
                           list.querySelectorAll('li a[tabindex="-1"],li span[tabindex="-1"]').forEach(function(tabIndexList) {
                              tabIndexList.setAttribute('tabindex', 0);
                           });
                        }
                     });
                  }
                  if (currentColstep == 'child') {
                     var colList = document.querySelector('.sidebar-menu-columns-parent .sidebar-menu-list-parent');
                     if (colList) {
                        colList.querySelectorAll('li a[tabindex="-1"],li span[tabindex="-1"]').forEach(function(tabIndexList) {
                           tabIndexList.setAttribute('tabindex', 0);
                        });
                     }
                  }
               }
            }
         });
      }

      // Scroll animated sections into view on focus
      if (typeof gsap !== 'undefined' && document.querySelectorAll('.animation-applied-element').length > 0) {
         gsap.set('.animation-applied-element', { clearProps: true });
         if (activeElement.closest('.animation-applied-element')) {
            setTimeout(function() {
               var active = document.activeElement;
               var section = active.closest('.animation-applied-element');
               if (active.closest('body#article') == null && section) {
                  gsap.to(window, { duration: 1, scrollTo: { y: section } });
               }
            }, 10);
         }
      }

      // Scroll product image into view on focus
      setTimeout(function() {
         var active = document.activeElement;
         if (active.closest('#product-image') && typeof gsap !== 'undefined') {
            if (active.closest('.single-product-image')) {
               active = active.closest('.single-product-image');
            } else if (active.closest('.model-container')) {
               active = active.closest('.model-container');
            } else if (active.closest('.external-video-container')) {
               active = active.closest('.external-video-container');
            } else if (active.closest('.video-container')) {
               active = active.closest('.video-container');
            }
            gsap.to(window, { duration: 1, scrollTo: { y: active } });
         }
      }, 5);

      // Product size guide drawer
      var sizeGuideBtn = document.querySelector('.js-size-guide-btn');
      var sizeGuideClose = document.querySelector('.js-close-size-guide');
      var sizeGuideLinks = document.querySelectorAll('.size-guide-contents a');
      var lastSizeGuideLink = sizeGuideLinks[sizeGuideLinks.length - 1];

      if (!event.shiftKey && event.key === "Tab") {
         if (lastSizeGuideLink != null && activeElement == lastSizeGuideLink) {
            document.body.classList.remove('show-size-guide');
            if (sizeGuideBtn) sizeGuideBtn.focus();
         }
      }

      if (event.key === "Enter") {
         if (sizeGuideBtn != null && sizeGuideClose != null) {
            if (activeElement == sizeGuideBtn) {
               sizeGuideClose.focus();
            }
            if (activeElement == sizeGuideClose) {
               document.body.classList.remove('show-size-guide');
               sizeGuideBtn.focus();
            }
         }
         // Size guide accordion accessibility
         document.querySelectorAll('.size-guide-content-accordion .product-accordion-item .faq-title').forEach(function(item) {
            if (activeElement == item) {
               activeElement.focus();
               item.classList.toggle('active');
               var faqContent = item.closest('.product-accordion-item')?.querySelector('.faq-content');
               if (faqContent) faqContent.classList.toggle('active');
            }
         });
      }
   }, 5);
});
